__turbopack_context__.v({
  "chatPanel": "fO7eZW_chatPanel",
  "chatPanel__activeFilters": "fO7eZW_chatPanel__activeFilters",
  "chatPanel__channelHeader": "fO7eZW_chatPanel__channelHeader",
  "chatPanel__clearFilterButton": "fO7eZW_chatPanel__clearFilterButton",
  "chatPanel__composer": "fO7eZW_chatPanel__composer",
  "chatPanel__composerReadOnly": "fO7eZW_chatPanel__composerReadOnly",
  "chatPanel__count": "fO7eZW_chatPanel__count",
  "chatPanel__deletedMessageBody": "fO7eZW_chatPanel__deletedMessageBody",
  "chatPanel__destination": "fO7eZW_chatPanel__destination",
  "chatPanel__destinationActive": "fO7eZW_chatPanel__destinationActive",
  "chatPanel__destinationCount": "fO7eZW_chatPanel__destinationCount",
  "chatPanel__destinationDisclosure": "fO7eZW_chatPanel__destinationDisclosure",
  "chatPanel__destinationDisclosureIcon": "fO7eZW_chatPanel__destinationDisclosureIcon",
  "chatPanel__destinationDisclosureLabel": "fO7eZW_chatPanel__destinationDisclosureLabel",
  "chatPanel__destinationGroup": "fO7eZW_chatPanel__destinationGroup",
  "chatPanel__destinationGroupHeader": "fO7eZW_chatPanel__destinationGroupHeader",
  "chatPanel__directMessageMember": "fO7eZW_chatPanel__directMessageMember",
  "chatPanel__directMessageResults": "fO7eZW_chatPanel__directMessageResults",
  "chatPanel__directMessageSearch": "fO7eZW_chatPanel__directMessageSearch",
  "chatPanel__divider": "fO7eZW_chatPanel__divider",
  "chatPanel__empty": "fO7eZW_chatPanel__empty",
  "chatPanel__emptyState": "fO7eZW_chatPanel__emptyState",
  "chatPanel__eyebrow": "fO7eZW_chatPanel__eyebrow",
  "chatPanel__headerContent": "fO7eZW_chatPanel__headerContent",
  "chatPanel__message": "fO7eZW_chatPanel__message",
  "chatPanel__messageActions": "fO7eZW_chatPanel__messageActions",
  "chatPanel__messageBody": "fO7eZW_chatPanel__messageBody",
  "chatPanel__messageContent": "fO7eZW_chatPanel__messageContent",
  "chatPanel__messageEditor": "fO7eZW_chatPanel__messageEditor",
  "chatPanel__messageMeta": "fO7eZW_chatPanel__messageMeta",
  "chatPanel__messageOptions": "fO7eZW_chatPanel__messageOptions",
  "chatPanel__messageSource": "fO7eZW_chatPanel__messageSource",
  "chatPanel__messages": "fO7eZW_chatPanel__messages",
  "chatPanel__replyButton": "fO7eZW_chatPanel__replyButton",
  "chatPanel__replyPreview": "fO7eZW_chatPanel__replyPreview",
  "chatPanel__replyPreviewBody": "fO7eZW_chatPanel__replyPreviewBody",
  "chatPanel__replyPreviewList": "fO7eZW_chatPanel__replyPreviewList",
  "chatPanel__replyPreviewMeta": "fO7eZW_chatPanel__replyPreviewMeta",
  "chatPanel__replyingBar": "fO7eZW_chatPanel__replyingBar",
  "chatPanel__sidePanel": "fO7eZW_chatPanel__sidePanel",
  "chatPanel__sidePanelBackdrop": "fO7eZW_chatPanel__sidePanelBackdrop",
  "chatPanel__sidePanelBody": "fO7eZW_chatPanel__sidePanelBody",
  "chatPanel__sidePanelEmpty": "fO7eZW_chatPanel__sidePanelEmpty",
  "chatPanel__sidePanelHeader": "fO7eZW_chatPanel__sidePanelHeader",
  "chatPanel__sidePanelOpen": "fO7eZW_chatPanel__sidePanelOpen",
  "chatPanel__title": "fO7eZW_chatPanel__title",
  "chatPanel__titleRow": "fO7eZW_chatPanel__titleRow",
  "chatPanel__titleSeparator": "fO7eZW_chatPanel__titleSeparator",
});
